var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-table", {
        attrs: {
          small: "",
          fields: _vm.fields,
          items: _vm.data.operationSteps,
          responsive: "sm",
        },
        scopedSlots: _vm._u([
          {
            key: "cell(#)",
            fn: function (data) {
              return [_vm._v(" " + _vm._s(data.index + 1) + " ")]
            },
          },
          {
            key: "cell(startDate)",
            fn: function (data) {
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.dayjs(data.value).format("DD/MM/YYYY hh:mm:ss")
                    ) +
                    " "
                ),
              ]
            },
          },
          {
            key: "cell(endDate)",
            fn: function (data) {
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.dayjs(data.value).format("DD/MM/YYYY hh:mm:ss")
                    ) +
                    " "
                ),
              ]
            },
          },
          {
            key: "cell(Popularity)",
            fn: function (data) {
              return [
                _c("b-progress", {
                  attrs: {
                    value: data.value.value,
                    max: "100",
                    variant: data.value.variant,
                    striped: "",
                  },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }